import 'css-chunk:../node_modules/.pnpm/simplebar@5.3.6/node_modules/simplebar/dist/simplebar.min.css';export default {};